import { DragonAssistantChatProvider } from './lib/chat-context';
import { QueryProvider } from './lib/client';
import { DragonAssistantLayoutProvider } from './lib/layout-context';

export function DragonAssistantGlobalProvider(props: { children: React.ReactNode }) {
  return (
    <QueryProvider>
      <DragonAssistantLayoutProvider>
        <DragonAssistantChatProvider>{props.children}</DragonAssistantChatProvider>
      </DragonAssistantLayoutProvider>
    </QueryProvider>
  );
}
